
import { DxTabPanel, DxItem } from 'devextreme-vue/tab-panel';
import ConsideracionTab from './cotizacionconsideracion.vue';

export default {
  components: {
    DxTabPanel, DxItem, ConsideracionTab
  },
  props: {
    masterDetailData: {
      type: Object,
      default: () => ({}),
    },
  },
};
